<template>
  <div id="app" :class="settings.lang == 'th' ? 'th-lang' : 'en-lang'">
    <launch-screen />
    <div>
      <header-section :profile="profile" />
      <div v-if="status.position < questions.length">
        <quiz-view :questions="questions[status.position]" @submit:response="submitQuestion" :settings="settings" />
        <place-marker :questions="questions" :status="status" />
      </div>

      <div v-else>
        <daily-summary :status="status" />
      </div>
    </div>
  </div>
</template>
<script>
import LaunchScreen from "@/components/LaunchScreen.vue";
import QuizView from "@/components/QuizView.vue";
import HeaderSection from "@/components/HeaderSection.vue";
import PlaceMarker from "@/components/PlaceMarker.vue";
import DailySummary from "@/components/DailySummary.vue";
const axios = require('axios');

export default {
  name: "app",
  components: {
    LaunchScreen,
    QuizView,
    HeaderSection,
    PlaceMarker,
    DailySummary
  },
  created() {
    var currentUrl = window.location.pathname;
    if (currentUrl == '/en') {
      this.settings.lang = 'en';
    }
  },
  data() {
    return {
      answers:[],
      questions: [
        {
          id: 1,
          question: "How are you feeling today?",
          question_th: "ที่ทำงานวันนี้เป็นยังไงบ้าง?",
          category: "happiness",
          type: "multiple",
          options: [
            "Very Happy",
            "Pretty Good",
            "Just Okay",
            "Not Great",
            "Terrible"
          ],
          options_th: [
            "เยี่ยม",
            "ก็ดีนะ",
            "เรื่อยๆ",
            "ไม่ค่อยจะดี",
            "แย่"
          ],
          coins: 1
        },
        {
          id: 2,
          question: "On a scale 0 to 10, how likely will you use Happily?",
          question_th: "จาก 0 ถึง 10 เป็นไปได้แค่ไหนที่คุณจะใช้ Happily?",
          category: "ambassadorship",
          type: "scale",
          coins: 5
        },
        {
          id: 3,
          question: "What in Happily are you most interested to use?",
          question_th: "อะไรใน Happily ที่คุณรู้สึกสนใจมากที่สุด?",
          category: "relmanager",
          type: "multiple",
          options: [
            "Feedback",
            "Insights",
            "Coaching & Sparks",
            "Happily Village & Rewards",
            "All of the above"
          ],
          options_th: [
            "Feedback",
            "Recognition",
            "Rewards",
            "Coaching & Sparks",
            "All of the above"
          ],
          coins: 1
        },
        {
          id: 4,
          question: "What is your role and the key people initiative that you're working on?",
          question_th: "งานของคุณเกี่ยวกับอะไร และสิ่งที่คุณอยากเห็น/อยากผลักดันให้เกิดขึ้นในองค์กรคือเรื่องใด?",
          category: "feedback",
          placeholder_text: "eg. HRD, people training and development",
          type: "open",
          coins: 2
        },
        {
          id: 5,
          question: "What are your main concerns with using Happily?",
          question_th: "เรื่องใด เป็นประเด็นหลักที่ทำให้คุณรู้สึกกังวลในการใช้งาน Happily?",
          category: "feedback",
          type: "open",
          coins: 3
        }
      ],
      profile: {
        name: "Happily Demo",
        totalcoins: 32,
        totalgems: 1
      },
      status: {
        position: 0,
        responses: [],
        coinsadded: 0,
        gemsadded: 0,
        feedback: 0,
        dayofweek: 0
      },
      settings: {
        lang: 'th'
      }
    };
  },
  methods: {
    submitQuestion(responseValue, coinValue, questionType) {
      //console.log(this.questions[this.status.position]);
      //console.log(responseValue+'=='+coinValue+'=='+questionType);
      this.answers.push({
        question:this.questions[this.status.position].question,
        response:responseValue,
      });
      this.profile.totalcoins = this.profile.totalcoins + coinValue;
      this.status.coinsadded = this.status.coinsadded + coinValue;

      this.status.position = this.status.position + 1;
      this.status.responses.push(responseValue);
      // console.log("Collected Responses: " + this.status.responses);

      if (questionType == "open" && coinValue != 0) {
        this.status.feedback = this.status.feedback + 1;
      }
      if (this.answers.length == this.questions.length) {
        let value ='';
        for (const x in this.answers) {
          value += `<b>Question</b> : ${this.answers[x].question}<br>`;
          value += `<b>Response</b> : ${this.answers[x].response}<br><br>`;
        }
        axios.post('https://api2.happily.ai/api/demofeedback', {
          value,
        });
      }
    }
  }
};
</script>

<style>
#app {
  font-family: "Lato";
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #333;
  position: relative;
}
</style>
